import { useContext, useCallback } from 'react';
import { AjaxContext, formatListData, AppContext } from 'commons-ui';
import _get from 'lodash/get';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const { app } = useContext(AppContext);
	const { isGold, appName } = app;

	const getVersionHistory = useCallback(
		(dashboard: string, pageName: string, entityName: string, id: string) =>
			async ({ pageDetails, sortDetails }: { pageDetails: any; sortDetails: any; filterDetails: any }) => {
				const result = await postData({
					endpoint: `/${dashboard}/${pageName}/${entityName}/getVersionHistory/${id}`,
					queryParams: {
						appName
					},
					body: {
						excludeFields: ['oldObject', 'newObject'],
						page: pageDetails,
						sortInfoArray: sortDetails,
						isNestedFields: true,
						isGold
					}
				});

				const data = _get(result, ['data', 'versionHistory'], []);

				const rowCount = _get(result, ['data', 'count'], 0);
				const listData = formatListData(data);
				return { rowCount, data: listData };
			},
		[]
	);

	const getVersionHistoryObjectById = useCallback(
		async (
			dashboard: string,
			pageName: string,
			entityName: string,
			id: string,
			entityId: string,
			_id: string,
			objectType: string
		) => {
			const result = await postData({
				endpoint: `/${dashboard}/${pageName}/${entityName}/getVersionHistory/${id}`,
				queryParams: {
					appName
				},
				body: {
					includeFields: [objectType],
					filters: [
						{
							field: '_id',
							operator: '$eq',
							value: _id
						}
					]
				}
			});
			const data = _get(result, ['data', 'versionHistory'], []);
			const rowCount = _get(result, ['data', 'count'], 0);
			const listData = formatListData(data);
			return { rowCount, data: listData };
		},
		[]
	);

	return {
		getVersionHistory,
		getVersionHistoryObjectById
	};
};

export default useService;
